module.exports = __webpack_public_path__ + "img/image_01.b5886aea.png";